import type { ToolkitTool } from '@/api/toolkit';

export const normalizeToolkitSearchQuery = (query: string): string => query.trim().toLowerCase();

/** Matches toolkit prompts by title (toolName) only — used for collections and My prompts. */
export const toolkitToolMatchesSearch = (tool: ToolkitTool, normalizedQuery: string): boolean => {
  if (!normalizedQuery) {
    return true;
  }

  return tool.toolName.toLowerCase().includes(normalizedQuery);
};
